import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { GroupAvatarUploadAction } from '../../domains/groupAvatarUploads/actions.types';
import type { GroupCoverImageUploadPendingAction } from '../../domains/groupCoverImages/actions.types';

import type { GroupAvatarUploads } from './types';

export type GroupAvatarUploadActions = GroupAvatarUploadAction | GroupCoverImageUploadPendingAction;

const initialState: GroupAvatarUploads = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupAvatarUploads, GroupAvatarUploadActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_AVATAR_UPLOAD.PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_AVATAR_UPLOAD.REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_AVATAR_UPLOAD.FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload });
    case 'GROUP_AVATAR_UPLOAD.DISMISS_ERROR':
      return remove(state, [action.groupId]);
    case 'GROUP_COVER_IMAGE.UPLOAD_PENDING':
      return remove(state, [action.payload.groupId]);
    default:
      return state;
  }
};

export default reducer;
